<template>
  <div class="login-page">
    <el-card class="login-card" shadow="hover">
      <div slot="header">
        <strong>管理员登录</strong>
      </div>
      <el-form :model="form" @submit.native.prevent="submit">
        <el-form-item label="用户名">
          <el-input v-model.trim="form.username" autocomplete="username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" show-password autocomplete="current-password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width:100%;" @click="submit">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/api/http'
import { saveAuth } from '@/auth'

export default {
  name: 'LoginView',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async submit() {
      if (!this.form.username || !this.form.password) {
        this.$message.warning('请输入用户名和密码')
        return
      }
      this.loading = true
      try {
        const { data } = await api.post('/auth/login', this.form)
        if (data.code === 1) {
          saveAuth(data.data || {})
          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)
          return
        }
        this.$message.error(data.message || '登录失败')
      } catch (e) {
        this.$message.error('网络错误')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: calc(100vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f6f8fb 0%, #e8eef7 100%);
}

.login-card {
  width: 420px;
  max-width: calc(100vw - 32px);
}
</style>
